import LS from '@utils/local-storage';
import apiRequest from '@src/utils/apiRequest';
import { CHECK_ACCEPTING_ORDER, NOTIFICATION_ACKNOWLEDGE } from '@src/config/apiEndpoints';

export const state = {
  oldNotyArr: [],
  notyArr: [],
  orderArr: [],
  orderArrOld: [],
  isChain: LS.get('is-chain'),
  cityId: LS.get('city-id'),
  orderAcceptingStatus: LS.get('order-accepting-status'),
};

export const getters = {
  getNotyObj: state => state.notyArr,
  getOrderObj: state => state.orderArr,
  isChain: state => state.isChain,
  cityId: state => state.cityId,
  getOrderAcceptingStatus: state => state.orderAcceptingStatus,
};

export const mutations = {
  STORE_NOTY_OBJ(state, payload) {
    state.oldNotyArr.unshift(payload);
    state.notyArr = state.oldNotyArr;
  },
  STORE_ORDER_OBJ(state, payload) {
    state.orderArrOld.unshift(payload);
    state.orderArr = state.orderArrOld;
  },
  UPDATE_IS_CHAIN(state, payload) {
    state.isChain = payload;
    LS.set('is-chain', payload, 86400000); // cache for 1 day
  },
  UPDATE_CITY_ID(state, payload) {
    state.cityId = payload;
    LS.set('city-id', payload, 86400000); // cache for 1 day
  },
  UPDATE_ACCEPTING_ORDER_STATUS(state, payload) {
    state.orderAcceptingStatus = payload;
    LS.set('order-accepting-status', payload, 3600000); // cache for 1 hour
  },
};

export const actions = {
  fetchNotyObj({ commit, state, rootState }, payload) {
    commit('STORE_NOTY_OBJ', payload);
  },
  fetchOrderObj({ commit, state, rootState }, payload) {
    commit('STORE_ORDER_OBJ', payload);
  },
  updateIsChain({ commit }, payload) {
    commit('UPDATE_IS_CHAIN', payload);
  },
  updateOrderAcceptingStatus({ commit }, payload) {
    commit('UPDATE_ACCEPTING_ORDER_STATUS', payload);
  },
  checkRestoStatus({ commit }) {
    return new Promise((resolve, reject) => {
      apiRequest({ url: CHECK_ACCEPTING_ORDER })
        .then(result => {
          commit('UPDATE_IS_CHAIN', result.data.restaurant_info.is_chain_resto);
          commit('UPDATE_ACCEPTING_ORDER_STATUS', result.data.accepting_order);
          commit('UPDATE_CITY_ID', result.data.restaurant_info.city_id);
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  sendNotificationAcknowledgement({ commit }, id) {
    if (!id) {
      return false;
    }

    return new Promise((resolve, reject) => {
      apiRequest({
        url: NOTIFICATION_ACKNOWLEDGE,
        method: 'POST',
        data: { notification_id: id },
      })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
